<template>
    <div class="grid-12">
        <div class="col-5 col-md-4 col-lg-3">
            <aside class="theme-sidebar">
                <div class="grid-12">
                    <div class="col-10 col-offset-1"><h2>Filter themes</h2></div>
                    <div class="col-10 col-offset-1"><h3>Search</h3></div>
                    <div class="col-10 col-offset-1">
                        <input id="themeSearchInput" type="text" placeholder="e.g. Theme name, hex code, tags">
                    </div>
                    <div class="col-10 col-offset-1"><h3>Sort by</h3></div>
                    <div class="col-10 col-offset-1">
                        <div class="dropdown">
                            <select v-model="themeFilter">
                                <option value="last_modified">Last Modified</option>
                                <option value="date_created">Date Created</option>
                                <option value="alpha">Alphabetical</option>
                                <option value="size"># of colors</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-10 col-offset-1"><h3>Sort direction</h3></div>
                    <div class="col-10 col-offset-1">
                        <div class="dropdown">
                            <select v-model="themeFilterDirection">
                                <option value="forward">Forward</option>
                                <option value="reverse">Reverse</option>
                            </select>
                        </div>
                    </div>  
                </div>
            </aside>
        </div>
        <div class="col-7 col-md-8 col-lg-9 theme-content-wrapper">
            <slot></slot>
        </div>
    </div>
</template>
<script type="text/javascript">
import dropdown from "@/assets/acute-framework/js/dropdown.js"
    export default {
        props:['sortMode', 'sortDirection'],
        data(){
            return {
                themeFilter:this.sortMode,
                themeFilterDirection:this.sortDirection,
            };
        },
        watch:{
            themeFilter(){
                this.$emit("update:sortMode",this.themeFilter);
            },
            themeFilterDirection(){
                this.$emit("update:sortDirection",this.themeFilterDirection);
            }
        },
        mounted(){
            dropdown.initDropdown();
        }
    }
</script>
<style type="text/css">
    .theme-sidebar{
        background-color: #f6f6f6;
        box-shadow: 5px 0 15px rgba(0,0,0,0.7);
        width: 100%;
        min-height: calc(100vh - 75px);
        height: 100%;
        font-size: 18px;
    }
    .theme-content-wrapper{
        max-height: calc(100vh - 75px);
        overflow-y: scroll;
    }
    .theme-sidebar input[type='text']{
        width: 100%;
        margin: 0 0 5% 0;
    }
    .theme-sidebar input[type='radio'],
    .theme-sidebar .dropdown
    {
        margin: 0 0 2% 0;
    }
    .theme-sidebar h2{
        font-weight: 500;
        font-size: 1.5em;
        letter-spacing: 2px;
        margin: 5% 0 2% 0;
        text-transform: uppercase;
    }
    .theme-sidebar h3{
        font-weight: 500;
        font-size: 1.22em;
        letter-spacing: unset;
        margin: 0 0 5% 0;
    }
    .theme-sidebar label{
        margin: 2% 4%;
        font-size: 1em;
    }
</style>